<template>
  <mask-side-section-container :title="$tc('DuctEntry', 1)">
    <v-flex
      shrink
      class="tab-content px-0 py-1 scroll-fire-fox"
      style="height: 100%; overflow: auto"
    >
      <input-field
        :value="ductEntry.mde_label"
        @input="updateDuctEntry('mde_label', $event)"
        label="Label"
        input-type="text"
        size="large"
        :field-disabled="disabled"
      />
      <!--      <input-field
        v-model="ductEntry.mde_default_destination"
        label="External Destination"
        input-type="radio"
        size="large"
        :field-disabled="disabled"
        :radio-options="[
          { label: 'Default', value: 1 },
          { label: 'Other', value: 0 }
        ]"
      />-->
      <!--      <input-field
        :value="ductEntry.mde_destination_specific_manhole"
        label="Destination Manhole"
        inputType="other"
        size="large"
        :field-disabled="disabled"
      >
        <div>
          <treeselect
            v-model="ductEntry.mde_destination_specific_manhole"
            :options="manholeOptions"
            :disabled="disabled"
            class="form-input-select"
            disableFuzzyMatching
          />
        </div>
      </input-field>-->
      <input-field
        :value="ductEntry.mde_destination_specific_manhole_uuid"
        @input="
          updateDuctEntry('mde_destination_specific_manhole_uuid', $event)
        "
        label="Destination Manhole"
        inputType="text"
        size="large"
        :field-disabled="disabled"
      />
      <input-field
        :value="ductEntry.mde_destination_specific_mask"
        label="Destination Mask"
        inputType="other"
        size="large"
        :field-disabled="disabled"
      >
        <div>
          <treeselect
            :value="ductEntry.mde_destination_specific_mask"
            @input="updateDuctEntry('mde_destination_specific_mask', $event)"
            :options="maskOptions"
            class="form-input-select"
            disableFuzzyMatching
          />
        </div>
      </input-field>
      <input-field
        :value="ductEntry.mde_state"
        @input="updateDuctEntry('mde_state', $event)"
        label="State"
        input-type="select"
        size="large"
        select-options="list_duct_state"
        :field-disabled="disabled"
      />

      <input-field
        v-if="ductEntry.mde_state === '1'"
        :value="ductEntry.mde_total_reservation"
        @change="updateDuctEntry('mde_total_reservation', $event)"
        label=""
        input-type="checkbox"
        :checkboxOptions="totalReservationOption"
        size="large"
        :field-disabled="disabled"
      >
      </input-field>
      <input-field
        v-if="ductEntry.mde_state !== '1'"
        :value="ductEntry.mde_occupancy_rate"
        @input="updateDuctEntry('mde_occupancy_rate', $event)"
        label="Occupancy Rate (%)"
        inputType="select"
        selectOptions="list_duct_occupation_rates"
        size="large"
        :field-disabled="disabled"
      />
      <duct-entry-form-cable-selection
        :cables="ductEntry.duct_entry_cables"
        :disabled="disabled"
      />
    </v-flex>
  </mask-side-section-container>
</template>

<script>
import { mapActions } from "vuex";
import InputField from "../../../_Molecules/InputField";
import DuctEntryFormCableSelection from "./DuctEntryFormCableSelection";
import MaskSideSectionContainer from "../Masks/MaskSideSectionContainer";

export default {
  name: "DuctEntryForm",

  components: {
    MaskSideSectionContainer,
    DuctEntryFormCableSelection,
    InputField
  },

  data() {
    return {
      /*manholeOptions: [],*/
      maskOptions: [
        {
          id: "A",
          label: "A"
        },
        {
          id: "B",
          label: "B"
        },
        {
          id: "C",
          label: "C"
        },
        {
          id: "D",
          label: "D"
        }
      ],
      cableOptions: [],

      totalReservationOption: [
        { label: "Reserve whole duct", var_name: "mde_total_reservation" }
      ]
    };
  },

  computed: {
    disabled() {
      return this.$store.getters.isManholeMasksTabDisabled;
    },

    ductEntry() {
      return this.$store.getters.getSelectedDuctEntry;
    }
  },

  methods: {
    ...mapActions(["editDuctEntry"]),

    updateDuctEntry(field, value) {
      let dataToUpdate = [{ field: field, value: value }];
      this.editDuctEntry(dataToUpdate);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Masks/Duct/DuctEntryForm.vue